import { render, staticRenderFns } from "./transcript-client-modal.vue?vue&type=template&id=6685dbd1&"
import script from "./transcript-client-modal.vue?vue&type=script&lang=js&"
export * from "./transcript-client-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6685dbd1')) {
      api.createRecord('6685dbd1', component.options)
    } else {
      api.reload('6685dbd1', component.options)
    }
    module.hot.accept("./transcript-client-modal.vue?vue&type=template&id=6685dbd1&", function () {
      api.rerender('6685dbd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/modal/transcript-client-modal/transcript-client-modal.vue"
export default component.exports